import { computed } from "vue";
import { useScreenSize } from '@/Groups/Audioplayer/private/imports/screenSize';

const { isLessThanLG } = useScreenSize();

//---------------------------------------------------------------------
/**
 * Список подкастов из хранилища.
 * @type {import('vue').ComputedRef<Object>}
 */
const isAdaptive = computed(() => isLessThanLG.value );
//---------------------------------------------------------------------

/**
 * Композабл для определения адаптивного режима плеера
 *
 * @returns {Object}
 * @property {import('vue').ComputedRef<boolean>} isAudioplayerAdaptiveMode - Включен ли адаптивный режим для плеера
 */
export function useAudioplayerAdaptiveMode() {
  return {
    isAdaptive
  };
}